import { fetchAllMembersApi, fetchNewMembersApi, approveMembersApi, updateProfileApi, showTransactionByuserIDApi} from '../api/membersApi';
import {requestStarted,requestCompleted} from "./common"


export const setMembers =(membersData) => {
  return {
    type : "SET_MEMBERS_LIST",
    membersData
  }
}

export const setNewMembers =(newMembersData) => {
  return {
    type : "SET_NEW_MEMBERS_LIST",
    newMembersData
  }
}

export const setApprovedMembers =(response) => {
  return {
    type : "SET_NEW_MEMBERS_APPROVED",
    response
  }
}

export const editMember =(membersData) => {
  return {
    type : "EDIT_MEMBERS",
    membersData
  }
}

export const updateMember =(membersData) => {
  return {
    type : "UPDATE_MEMBERS",
    membersData
  }
}


export const setUserTransaction = (transactionData) =>{
  return {
    type : "SET_USER_TRANSACTION_DATA",    
    transactionData
  }
}

export const fetchAllMembers=(token) =>{
  return dispatch =>{
      dispatch(requestStarted());
    fetchAllMembersApi(token).then((result) =>{
       dispatch(requestCompleted());
     dispatch(setMembers(result));
    });
  }
}

export const fetchNewMembers=() =>{
  return dispatch =>{
      dispatch(requestStarted());
    fetchNewMembersApi().then((result) =>{
       dispatch(requestCompleted());
     dispatch(setNewMembers(result));
    });
  }
}


export const approveMembers=(id) =>{
  return dispatch =>{
      dispatch(requestStarted());
    approveMembersApi(id).then((result) =>{
       dispatch(requestCompleted());
     dispatch(setApprovedMembers(result));
    });
  }
}


export const updateProfile=(data) =>{
  return dispatch =>{
      dispatch(requestStarted());
    updateProfileApi(data).then((result) =>{
       dispatch(requestCompleted());
       if(result.success){
         alert(result.message);
         dispatch(updateMember(result));
       }
    });
  }
}

//showTransactionByuserID
export const showTransactionByuserID=(userId) =>{
  return dispatch =>{
      dispatch(requestStarted());
      showTransactionByuserIDApi(userId).then((result) =>{
       dispatch(requestCompleted());
     dispatch(setUserTransaction(result));
    });
  }
}


// WEBPACK FOOTER //
// ./src/actions/members.js